import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            setTimeout(()=> {
                this.conceptScroll()
            },100)
        });
        barba.hooks.after((data) => {
            setTimeout(()=> {
                this.conceptScroll()
            },100)
        });

    }
    conceptScroll(){
        const elem = document.querySelector('.js-scroll__concept');

        
        if(elem) {

            const bg = document.querySelector('#js-bgColor');
            const slider = document.querySelector('.js-scroll__slider');
    
            const items = document.querySelectorAll('.js-concept__items');
    
            const bgColors = ["#FCF9F4","#FDF6E5","#FAEDEA","#FAE4D3"]
            const sections = document.querySelectorAll('.p-index__concept--item')
            const totalDuration = elem.clientWidth;
            const singleDuration = (totalDuration / sections.length - 1);

            gsap.to(elem, {
                xPercent: -300,
                ease: 'none',
                scrollTrigger: {
                    trigger: slider,
                    start: 'top top', // 要素の上端（top）が、ビューポートの上端（top）にきた時
                    end: `+=${totalDuration}`, // リストの横幅分移動したら終わり
                    scrub: true,
                    pin: true,
                    // onUpdate: () => {
                    //     let width = window.innerWidth;
                    //     let style = window.getComputedStyle(elem);
                    //     let matrix = new WebKitCSSMatrix(style.webkitTransform);
                    //     let translateX = ('translateX: ', matrix.m41)
                    //     let percent = (translateX / width)
                    //     if(percent <= 0) {
                    //         items.forEach((item) => {
                    //             item.style.opacity = 1;
                    //         });
                    //     }
                    //     if(percent < 0) {
                    //         items.forEach((item) => {
                    //             item.style.opacity = 0;
                    //         });
                    //     }
                    //     if(percent < -0.5) {
                    //         bg.classList.add('is-features01');
                    //         features01.classList.add('is-active');
                    //     }
                    //     if(percent <= -0.9) {
                    //         features01.classList.add('is-active__line');
                    //     }
                    //     if(percent < -1.5) {
                    //         bg.classList.add('is-features02');
                    //         features02.classList.add('is-active');
                    //     }
                    //     if(percent <= -1.9) {
                    //         features02.classList.add('is-active__line');
                    //     }
                    //     if(percent < -2.5) {
                    //         bg.classList.add('is-features03');
                    //         features03.classList.add('is-active')
                    //     }
                    //     if(percent <= -2.9) {
                    //         features03.classList.add('is-active__line');
                    //     }
                    //     if(percent >= -1.5) {
                    //         bg.classList.remove('is-features02');
                    //     }
                    //     if(percent >= -2.5) {
                    //         bg.classList.remove('is-features03');
                    //     }
                    // }
                },
            });
            
            const headerBg = document.querySelector('.l-header__bg--el')
            gsap.to('#js-bgColor',
            { 
                duration: 1,
                backgroundColor: bgColors[0],
                scrollTrigger: {
                    start:  (singleDuration * 1),
                    end: "+=" + singleDuration ,
                    toggleActions: "play none reverse none",
                    invalidateOnRefresh: true,
                }
            })

            gsap.fromTo('.p-index__concept--views-item--move img',
            { 
                duration: .5,
                y:0
            },
            { 
                duration: .5,
                y:"25%",
                scrollTrigger: {
                    start: (singleDuration * 2),
                    end: "+=" +  (singleDuration * 1),
                    toggleActions: "play none restart none",
                    scrub:true,
                    invalidateOnRefresh: true
                }
            })

            gsap.to('.js-concept__items',
            { 
                duration: 1,
                opacity:0,
                scrollTrigger: {
                    start:  (singleDuration * 2.4),
                    end: "+=" + singleDuration ,
                    toggleActions: "play none reverse none",
                    scrub:true,
                    invalidateOnRefresh: true,
                }
            })
                        
            gsap.to('#js-bgColor',
            { 
                duration: 1,
                backgroundColor: bgColors[1],
                scrollTrigger: {
                    start:  (singleDuration * 2),
                    end: "+=" + singleDuration ,
                    toggleActions: "play none reverse none",
                    invalidateOnRefresh: true,
                    onEnter(){
                        headerBg.style.backgroundColor = "transparent"
                    },
                    onLeaveBack(){
                        headerBg.style.backgroundColor = bgColors[0]
                    }
                },
 
            })
            
            gsap.fromTo('.p-index__concept--item-pointer02',
            { 
                duration: 1,
                x:'200%',
                opacity:0,
                scale:.8
            },
            { 
                duration: 1,
                x:0,
                opacity:1,
                scale:1,
                scrollTrigger: {
                    start:  (singleDuration * 3),
                    end: "+=" + singleDuration ,
                    toggleActions: "play none restart none",
                    scrub:true,
                    invalidateOnRefresh: true,
                    onLeave(){
                        gsap.to('.p-index__concept--item-pointer02',
                        { 
                            duration: 1,
                            opacity:0,
                        })
                    }
                }
            })

            gsap.fromTo('.p-index__concept--views-item.-item02 img',
            { 
                duration: .5,
                y:'25%'
            },
            { 
                duration: .5,
                y:0,
                scrollTrigger: {
                    start:  (singleDuration * 2.5),
                    end: "+=" + singleDuration * 1.5 ,
                    toggleActions: "play none restart none",
                    scrub:true,
                    invalidateOnRefresh: true,
                    onLeave(){
                        gsap.to('.p-index__concept--views-item.-item02 img',
                        { 
                            duration: .5,
                            y:'25%'
                        })
                    }
                }
            })

            gsap.to('#js-bgColor',
            { 
                duration: 1,
                backgroundColor: bgColors[2],
                scrollTrigger: {
                    start: (singleDuration * 4),
                    end: "+=" + singleDuration,
                    toggleActions: "restart none reverse none",
                    invalidateOnRefresh: true,
                    onEnter(){
                        headerBg.style.backgroundColor = "transparent"
                    }
                }
            })

            gsap.fromTo('.p-index__concept--item-pointer03',
            { 
                duration: 1,
                x:'200%',
                opacity:0,
                scale:.8
            },
            { 
                duration: 1,
                x:0,
                opacity:1,
                scale:1,
                scrollTrigger: {
                    start:  (singleDuration * 4),
                    end: "+=" + singleDuration * 1.5 ,
                    toggleActions: "play none restart none",
                    scrub:true,
                    invalidateOnRefresh: true,
                    onLeave(){
                        gsap.to('.p-index__concept--item-pointer03',
                        { 
                            duration: 1,
                            opacity:0,
                        })
                    }
                }
            })

            gsap.fromTo('.p-index__concept--views-item.-item03 img',
            { 
                duration: .5,
                y:'25%'
            },
            { 
                duration: .5,
                y:0,
                scrollTrigger: {
                    start:  (singleDuration * 4),
                    end: "+=" + singleDuration ,
                    toggleActions: "play none restart none",
                    scrub:true,
                    invalidateOnRefresh: true,
                    onLeave(){
                        gsap.to('.p-index__concept--views-item.-item03 img',
                        { 
                            duration: .5,
                            y:'25%'
                        })
                    }
                }
            })

            gsap.to('#js-bgColor',
            { 
                duration: 1,
                backgroundColor: bgColors[3],
                scrollTrigger: {
                    start: (singleDuration * 5),
                    end: "+=" + singleDuration,
                    toggleActions: "restart none none none",
                    invalidateOnRefresh: true,
                    onEnter(){
                        headerBg.style.backgroundColor = "transparent"
                    },
                    onLeave(){
                        headerBg.style.backgroundColor = bgColors[0]
                    },
                    onEnterBack(){
                        headerBg.style.backgroundColor = "transparent"
                    }
                }
            }) 
            
            gsap.fromTo('.p-index__concept--item-pointer04',
            { 
                duration: 1,
                x:'200%',
                opacity:0,
                scale:.8
            },
            { 
                duration: 1,
                x:0,
                opacity:1,
                scale:1,
                scrollTrigger: {
                    start:  (singleDuration * 5),
                    end: "+=" + singleDuration ,
                    toggleActions: "play none restart none",
                    scrub:true,
                    invalidateOnRefresh: true,
                    
                }
            })
            
            gsap.fromTo('.p-index__concept--views-item.-item04 img',
            { 
                duration: .5,
                y:'25%'
            },
            { 
                duration: .5,
                y:0,
                scrollTrigger: {
                    start:  (singleDuration * 5),
                    end: "+=" + singleDuration * 2 ,
                    toggleActions: "play none restart none",
                    scrub:true,
                    invalidateOnRefresh: true,
                    onLeave(){
                        gsap.to('.p-index__concept--views-item.-item04 img',
                        { 
                            duration:.5,
                            y:'25%'
                        })
                    }
                }
            })
        }
        
    }
    // bgColorScroll(){
    //     this.bg = document.querySelector('#js-bgColor');
    //     this.el01 = document.querySelectorAll('.js-bgColor__sec01');
    //     this.el02 = document.querySelectorAll('.js-bgColor__sec02');
    //     if(this.bg) {
    //         this.el01.forEach(elfirst => {
    //             let color = elfirst.dataset.color;
    //             gsap.from(this.bg, {
    //                 backgroundColor: color,
    //                 scrollTrigger: {    
    //                     trigger: elfirst,
    //                     start: 'top center',
    //                     end: 'bottom center',
    //                     markers: true,
    //                     // toggleActions: 'play pause resume restart',
    //                     onEnter: () => gsap.to(this.bg, {backgroundColor:color}), 
    //                     onLeave: () => gsap.to(this.bg, {backgroundColor:'#FDF6E5'}), 
    //                     onLeaveBack: () => gsap.to(this.bg, {backgroundColor:'#FDF6E5'}), 
    //                     onEnterBack: () => gsap.to(this.bg, {backgroundColor:color}), 
    //                 }
    //             })
    //         })
    //         this.el02.forEach(elSecond => {
    //             let color = elSecond.dataset.color;
    //             gsap.from(this.bg, {
    //                 backgroundColor: color,
    //                 scrollTrigger: {    
    //                     trigger: elSecond,
    //                     start: 'top center',
    //                     end: 'bottom center',
    //                     markers: true,
    //                     // toggleActions: 'play pause resume restart',
    //                     onEnter: () => gsap.to(this.bg, {backgroundColor:color}), 
    //                     onLeave: () => gsap.to(this.bg, {backgroundColor:'#FAEDEA'}), 
    //                     onLeaveBack: () => gsap.to(this.bg, {backgroundColor:'#FAEDEA'}), 
    //                     onEnterBack: () => gsap.to(this.bg, {backgroundColor:color}), 
    //                 }
    //             })
    //         })
    //     }
    // }
}